import { RequestTypeEnum } from "@nlc/shared-types";

export const CREATIVE_DIRECTION_OPTIONS = [
  { id: "Designer has creative freedom", label: "Creative freedom" },
  { id: "Follow brief exactly", label: "Follow brief exactly" },
];

export const SIZE_SUGGESTIONS = [
  "1080x1080",
  "1080x1920",
  "1920x1080",
  "1200x628",
  "1080x1350",
  "1280x720",
];

export const FILE_TYPE_SUGGESTIONS = {
  [RequestTypeEnum.GRAPHIC]: ["PNG", "JPG", "PDF", "SVG", "WEBP", "AI", "PSD"],
  [RequestTypeEnum.VIDEO]: ["MP4", "MOV", "WEBM", "GIF", "AVI"],
};
